var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBloodDonation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.1821589 8c-8.9371596 0-16.1821589 4.3893242-16.1821589 16.1821589 0 11.7928346 29.0326968 33.283923 29.0326968 33.283923s29.0326967-21.4910884 29.0326967-33.283923c0-11.7928347-7.2449993-16.1821589-16.1821588-16.1821589-5.2369705 0-9.8929055 2.487709-12.8505379 6.3458602-2.9576325-3.8581512-7.6135674-6.3458602-12.8505379-6.3458602z",
    fill: "#e43535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 37.395h11.786l2.792-9.197 3.285 13.911 3.769-24.109 3.917 30.143 4.342-25.133 2.562 14.844h20.993",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodDonation);
export default __webpack_public_path__ + "static/media/BloodDonation.66976557064529d8964bc3d98812c794.svg";
export { ForwardRef as ReactComponent };